import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { parse } from 'qs'
import { useIntl } from 'react-intl'
import { Box, Container, Typography } from '@mui/material'

import { setEmailManagement } from '../../slices'
import { EmailManagementTable } from '../table/email-management-table.component'
import { EmailManagementFilter } from '../filter/email-management-filter.component'
import { EMAIL_MANAGEMENT_DEFAULT_QUERY } from '../../constants/email-management-filters.constants'
import { hasEmailManagementPermission } from '../../utils/permissions.utils'

export const EmailManagementDashboard = () => {
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const role = useSelector((state) => state.global.role)
  const permissions = useSelector((state) => state.global.permissions)

  const url = useLocation().search
  const urlSearchParams = parse(url.split('?')[1])
  const searchParams = {
    ...EMAIL_MANAGEMENT_DEFAULT_QUERY,
    ...urlSearchParams,
  }

  useEffect(() => {
    dispatch(setEmailManagement(searchParams))
  }, [url])

  const hasValidPermissionAndRole = hasEmailManagementPermission(role, permissions)

  return (
    <Box>
      <Container
        maxWidth="lg"
        sx={(theme) => ({
          height: '100%',
          alignItems: 'center',
          padding: '50px 40px',
          [theme.breakpoints.down('md')]: {
            padding: '30px 20px',
          },
        })}
      >
        <Box mb={2}>
          <Typography variant="h4" color="text.secondary">
            {formatMessage({ id: 'pages.emailManagement.title' })}
          </Typography>
        </Box>

        <Box mb={2}>
          <EmailManagementFilter />
        </Box>
        <Box>
          <EmailManagementTable />
        </Box>
      </Container>
    </Box>
  )
}
